<script setup lang="ts">
import { computed, toRef } from "vue";
import { useCardLocalOptions } from "@/composables/useCardLocalOptions";
import type { ResultsCard } from "@/types";
import OptionRow from "./OptionRow.vue";
import { Select } from "@/components/episto-ui/select";
import { useCardPopulation } from "@/components/Survey/ResultsV2/analysisData";

const props = defineProps<{
  card: Pick<ResultsCard, "id" | "options">;
}>();

const card = toRef(props, "card");
const { updateLocalOption } = useCardLocalOptions(card);
const { choices, selected } = useCardPopulation(card);

const options = computed(() => choices.value.map((choice) => ({ value: choice.token, label: choice.label })));
</script>

<template>
  <OptionRow
    label="Population"
    hint="The population the analysis is computed on.">
    <Select
      :model-value="selected"
      :options="options"
      @update:model-value="updateLocalOption('population', $event)" />
  </OptionRow>
</template>
